<p-toast></p-toast>
<router-outlet></router-outlet>
<app-size-detector></app-size-detector>
